/**
 * Shared coach avatar circle + its deterministic color, used by the coach
 * picker and the per-game effective-coverage list so the two can't drift.
 */

const AVATAR_COLORS = ["#2563eb", "#0891b2", "#7c3aed", "#d97706", "#16a34a", "#db2777", "#4f46e5"];

/** Deterministic avatar background color from a user id. */
const avatarColor = (id: string) => {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
};

interface AvatarProps {
  id: string;
  initials: string;
  /** Highlight the current user with a ring. */
  ring?: boolean;
  title?: string;
}

/** Small initials circle used for coaches. */
export const Avatar = ({ id, initials, ring, title }: AvatarProps) => (
  <span
    className={`sf-avatar${ring ? " sf-avatar--ring" : ""}`}
    style={{ background: avatarColor(id) }}
    title={title}
  >
    {initials}
  </span>
);

/** A crisp, perfectly-centered plus glyph for "add" circles (avoids font-metric
 *  off-centering of a literal "+" character). */
export const PlusIcon = () => (
  <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M6 1.75v8.5M1.75 6h8.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);
